import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/vat',
}).lazy(() => import('./vat.index.lazy').then((d) => d.Route))
